import { render } from "./Ios.vue?vue&type=template&id=89b5d49e"
import script from "./Ios.vue?vue&type=script&lang=js"
export * from "./Ios.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__